import { select, locked } from "../ui.js";
import { ENGINE_CHOICES, TRANSPORT_CHOICES, AUTO_REASONS, normalizeEngine } from "../../shared/settings-schema.js";
import { get } from "../../shared/settings-store.js";

// Why pages open with Standard (v1) while Standard is selected, in the words of the connection dot
// (shared/settings-schema.js AUTO_REASONS). The app keeps the server's pause switch in
// rv:engine-flags (app/proxy.js) and the reason Standard could not start in this browser in
// rv:engine-reason (app/engines.js: browser, worker, start).
function standardReason() {
	try { const f = JSON.parse(localStorage.getItem("rv:engine-flags") || "{}"); if (f && f.sj2 === "off") return AUTO_REASONS.paused; } catch { /* storage off */ }
	try { const r = localStorage.getItem("rv:engine-reason"); if (r && r !== "paused" && r !== "site" && AUTO_REASONS[r]) return AUTO_REASONS[r]; } catch { /* storage off */ }
	return "";
}

// Where websites open (docs/security/PHASE1-PLAN.md): app/sbx.js records the last choice only while
// the separate address is switched on, so this row is absent in the default mode.
function secureMode() {
	let t = null;
	try { t = localStorage.getItem("rv:sbx-tier"); } catch { /* storage off */ }
	if (t === "A") return "On: websites open on a separate address, away from your Re:Vault data.";
	if (t === "legacy") return "Unavailable right now, using the standard connection.";
	return "";
}

export const proxyControls = {
	engine: () => {
		const sel = select("engine", ENGINE_CHOICES);
		const why = normalizeEngine(get("engine")) === "scramjet2" ? standardReason() : "";
		if (!why) return sel;
		const w = document.createElement("div");
		w.className = "rv-stack";
		const n = document.createElement("div");
		n.className = "rv-row-desc";
		n.textContent = why;
		w.append(sel, n);
		return w;
	},
	transport: () => select("transport", TRANSPORT_CHOICES),
	// Only while websites open on the separate address; the row hides itself otherwise.
	secureMode: () => {
		const sm = secureMode();
		const l = locked(sm ? (sm.startsWith("On") ? "On" : "Standard") : "");
		if (sm) l.title = sm;
		l.dataset.empty = sm ? "" : "1";
		return l;
	},
};
